import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogResult, PopupDialog } from '@app/Common';
import { TenantService } from '@app/Services/tenant.service';
import { DeleteViewModel } from '@app/Tenant/Applications/Airsweb/Models/delete.view-model';
import { Router } from '@angular/router';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-delete-tenant',
    templateUrl: './tenant.delete.component.html',
    styleUrls: ['./tenant.delete.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatIcon, MatButton]
})
export class TenantDeleteComponent implements OnInit {
  viewModel: DeleteViewModel;
  busy: boolean;
  busyMessage: string;
  processComplete: boolean;

  public constructor(
    private tenantService: TenantService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (!this.tenantService || !this.tenantService.selectedTenant) {
      return;
    }

    this.viewModel = new DeleteViewModel();
    this.viewModel.TenantName = this.tenantService.selectedTenant.Value;
  }

  delete(): void {
    this.busyMessage = `Deleting ${this.viewModel.TenantName}...`;
    this.busy = true;

    this.tenantService.delete(this.viewModel.TenantName).subscribe(
      (tenantId) => {
        this.viewModel.TenantId = tenantId;

        this.processComplete = true;
        this.busy = false;

        if (
          this.viewModel.TenantId === '00000000-0000-0000-0000-000000000000'
        ) {
          this.viewModel.Failed = true;
          return;
        }

        this.viewModel.Failed = false;
        this.router.navigateByUrl('/');
      },
      (error) => {
        this.viewModel.RequestError = error.ExceptionMessage;
        this.viewModel.Failed = true;
        this.processComplete = true;
        this.busy = false;
      }
    );
  }

  showDeleteConfirmationDialog(): void {
    const dialogRef =
      this.dialog.open<PopupDialog, any, DialogResult>(PopupDialog);
    dialogRef.componentInstance.DialogTitle = 'Delete Tenant';
    dialogRef.componentInstance.DialogDescription = `Are you sure you want to delete tenant <b>${this.viewModel.TenantName}</b>?`;
    dialogRef.componentInstance.DialogConfirmButtonText = 'Confirm';
    dialogRef.componentInstance.DialogCancelButtonText = 'Cancel';

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && result.Result) {
        this.delete();
      }
    });
  }
}
